import mainStore from "store/mainStore";
import { useWizardStore } from "store/wizardStore";
import { PlusCircleIcon } from "components/Icons";

function getDefAmount() {
  const { record: mainRecord } = mainStore.getState();
  const { store } = useWizardStore.getState();
  const amount = Math.round(mainRecord.pending_to_pay);
  store.amount = amount;
  return amount;
}

const getView = () => {
  const DictCtxView = {
    model: "hotel.booking.add_payment",
    form_action: [],
    table_action: [],
    webfields: {
      statement: {
        type: "many2one",
        model: "account.statement",
        readOnly: false,
        required: true,
        recSearch: () => [["state", "=", "draft"]],
      },
      amount: {
        type: "numeric",
        readOnly: false,
        required: true,
        default: getDefAmount,
      },
      voucher: {
        type: "char",
        readOnly: false,
        // required: true,
      },
      pay: {
        type: "button",
        // method: addPayment, This method is added in custom model
        color: "green",
        iconRight: <PlusCircleIcon className="h-5 w-5 fill-current" />,
      },
    },
    webform: [
      { name: "statement" },
      { name: "amount" },
      { name: "voucher" },
      { name: "pay" },
    ],
  };

  return DictCtxView;
};

export default { ctxView: getView };
